import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const FrenchBadge = () => {
  const [open, setOpen] = useState(false);

  return (
    <motion.div
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ delay: 1.5, duration: 0.5 }}
      className="fixed right-0 bottom-36 z-40"
      data-testid="french-badge"
    >
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center overflow-hidden shadow-md ring-1 ring-black/5 rounded-l-sm cursor-pointer hover:shadow-lg transition-shadow"
      >
        <AnimatePresence mode="wait">
          {open ? (
            <motion.div
              key="expanded"
              initial={{ width: 0, opacity: 0 }}
              animate={{ width: "auto", opacity: 1 }}
              exit={{ width: 0, opacity: 0 }}
              transition={{ duration: 0.25 }}
              className="flex items-center bg-white overflow-hidden"
            >
              <div className="px-3 py-2 whitespace-nowrap">
                <p className="text-[11px] font-heading font-bold text-charcoal leading-tight">
                  Startup française
                </p>
                <p className="text-[10px] text-muted-foreground leading-tight">
                  et fière de l'être !
                </p>
              </div>
            </motion.div>
          ) : null}
        </AnimatePresence>
        <div className="flex flex-row h-10">
          <div className="w-2.5 h-full bg-[#002395]" />
          <div className="w-2.5 h-full bg-white" />
          <div className="w-2.5 h-full bg-[#ED2939]" />
        </div>
      </button>
    </motion.div>
  );
};

export default FrenchBadge;
